document.addEventListener('DOMContentLoaded', async () => {
  // import('focus-visible').then((module) => module) // Not needed in this project

  // utilities

  import('utility/page-restore').then((module) => module.default.init())
  import('utility/prefetch').then((module) => module.default.init())
  import('utility/smooth-scroll').then((module) => module.default.init())
  import('utility/vertical-resize-check').then((module) => module.default.init())

  // components

  if (document.querySelector<HTMLElement>('.cursor')) {
    import('./components/hr-cursor').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.loader')) {
    import('./components/hr-loader').then((module) => module.default.init())
  }

  // sections

  if (document.querySelector<HTMLElement>('.booking')) {
    import('./sections/hr-booking').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header')) {
    import('./sections/hr-header').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.hero')) {
    import('./sections/hr-hero').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.info')) {
    import('./sections/hr-info').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.offer')) {
    import('./sections/hr-offer').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.reviews')) {
    import('./sections/hr-reviews').then((module) => module.default.init())
  }

  // dev helpers

  if (process.env.NODE_ENV !== 'production') {
    import('utility/overlay-grid').then((module) => module.default.init())
  }

  setTimeout(() => {
    document.body.classList.remove('noscript')
    document.body.classList.remove('preload')
  }, 100)
})
